import React, {useEffect, useState} from "react";

import {Button, Col, Form, Layout as AntLayout, message, Modal, Row, Space} from 'antd';
import {
    AppButton,
    Container,
    ContainerStep,
    Logo,
    PageContent,
    PageFooter,
    PageHeader,
    ScheduleStep,
    StepsBody,
    Title
} from "./styles";
import Identification from "../../pages/Identification";
import Vehicles from "../../pages/Vehicles";
import ConfirmData from "../../pages/ConfirmData";
import Schedule from "../../pages/Schedule";
import Finish from "../../pages/Finish";
import ScheduleData from "../../models/ScheduleData";
import Response from "../../models/Response";
import api from "../../service/api";

import {LoadingOutlined} from '@ant-design/icons';
import Vehicle from "../../models/Vehicle";
import HistoryKey from "../../models/HistoryKey";
import ItemVacancy from "../../models/ItemVacancy";
import {NormalizeCpfOrCnpj, StringOnlyNumbers} from "../../utils/StringUtils";
import AppParameters from "../../models/AppParameters";
import {AppSpin} from "../../global/styles";

import ScheduleInspection from "../../models/ScheduleInspection";
import {downloadFromBase64} from "../../utils/FileUtils";
import {Constants} from "../../utils/Constants";
import {environment} from "../../environments/environment";
import {decryptBase64Safe} from "../../utils/CryptoUtils";
import {Link as RouterLink, useLocation} from "react-router-dom";


interface FormScheduleData {
    contactName: string,
    contactDDD: number,
    contactNumber: string,
    pontoDeReferencia: string,
    obsReserveExternal: string,
    attendanceForm: string,
    period: string,
    clientAddress: string
}

interface LayoutProps {
    typeService: string;
}

const Layout: React.FC<LayoutProps> = ({typeService}) => {
    useLocation();
    const {Step} = ScheduleStep;
    const [current, setCurrent] = useState<number>(0);

    const [form] = Form.useForm();
    const [dots, setDots] = useState('.');
    const [loadStep, setLoadStep] = useState<boolean>(false);
    const [scheduleData, setScheduledata] = useState<ScheduleData>({} as ScheduleData);
    const [vehicleData, setVehicleData] = useState<Vehicle>({} as Vehicle);
    const [historyKey, setHistoryKey] = useState<string>('');
    const [resetStep, setResetSep] = useState<boolean>(false);
    const [vacancyData, setVacancyData] = useState<ItemVacancy>({} as ItemVacancy);
    const [emailInformed, setEmailInformed] = useState<string>('');
    const [formScheduleData, setFormScheduleData] = useState<FormScheduleData>({} as FormScheduleData);
    const [appParameters, setAppParameters] = useState<AppParameters>({} as AppParameters);
    const [enableNext, setEnableNext] = useState<boolean>(false);
    const [cameFromCancelling, setCameFromCancelling] = useState<boolean>(true);
    const [cpfCnpjParam, setCpfCnpjParam] = useState<any>();
    const [newVirtualSchedule] = useState<boolean>(true);
    let [typeSchedule, setTypeSchedule] = useState<any>();

    const handleFormChange = (isValid: boolean): void => {
        setEnableNext(isValid);
    };

    useEffect(() => {
        if (window.location.href.includes('suhai')) {
            setAppParameters({
                company: 'Suhai',
                urlFavicon: 'favicon-suhai.png',
                urlLogo: 'logo-suhai.svg',
                primaryColor: '#24695c',
                secondaryColor: '#24695c',
                fontColor: '#fff',
                footerText: `Seu veículo bem-vindo, você seguro. ` + `${environment.version}`
            } as AppParameters);
        } else {
            let typeService;
            if (window.location.href.includes('/instalacao')) {
                typeService = 'Instalação';
                typeSchedule = 1;
            } else if (window.location.href.includes('/revisao')) {
                typeService = 'Revisão';
                typeSchedule = 2;
            } else if (window.location.href.includes('/desinstalacao')) {
                typeService = 'Desinstalação';
                typeSchedule = 3;
            } else if (window.location.href.includes('/layout-cancellation')) {
                typeService = 'Cancelamento';
                typeSchedule = 4;
            } else {
                window.location.href.includes('/instalacao')
                typeService = 'Instalação';
                typeSchedule = 1;
            }
            setTypeSchedule(typeSchedule);
            setAppParameters({
                company: 'Tracker',
                urlFavicon: 'favicon-tracker.png',
                urlLogo: 'logo-tracker.png',
                primaryColor: '#e9e9e9',
                secondaryColor: '#DC3644',
                fontColor: 'rgba(0, 0, 0, 0.85)',
                footerText: `Grupo Tracker.` + ` ${environment.version}`,
                typeService: typeService
            } as AppParameters);
        }
    }, [])

    useEffect(() => {
        const favicon = document.getElementById("favicon") as HTMLLinkElement;
        favicon.href = appParameters.urlFavicon;
    }, [appParameters])

    useEffect(() => {
        if (resetStep) {
            form.resetFields();
            setCurrent(0);
        }
    }, [resetStep, form])

    useEffect(() => {
        // Verifica se está no primeiro passo (onde o usuário informa o CPF ou CNPJ)
        if (current === 0) {
            // Obtém os parâmetros da URL
            const urlParams = new URLSearchParams(window.location.search);
            // Verifica se existe um parâmetro chamado cpfCnpjParam na url
            if (urlParams.get('cpfCnpjParam')) {
                const encryptedCpfCnpjParam = urlParams.get('cpfCnpjParam');
                if (encryptedCpfCnpjParam) {
                    // const bytes = AES.decrypt(encryptedCpfCnpjParam, secretKey);
                    const decryptedData = decryptBase64Safe(encryptedCpfCnpjParam);
                    // Salvo o cpf/cnpj que veio como parãmetro em uma variável global
                    setCpfCnpjParam(decryptedData);
                }
                // Seto que veio do sistema de cancelamento de agendamentos.
                setCameFromCancelling(true);
                // Chama a função que avança para o próximo passo
                next();
            } else {
                setCameFromCancelling(false);
            }
        }
    }, [cpfCnpjParam, current]);

    useEffect(() => {
        if (current === 3) {
            setEnableNext(false);
        }
    }, [current]);

    useEffect(() => {
        const interval = setInterval(() => {
            setDots(prev => (prev.length >= 3 ? '.' : prev + '.'));
        }, 500);
        return () => clearInterval(interval);
    }, []);

    const onDownloadPdf = async (scheduleInspec: ScheduleInspection) => {

        // console.log('---------- INICIO ----------')
        // console.log('URL : /export-files-service/proofOfAppointment');
        // console.log('protocol: ' + scheduleInspec.fnReserveId);
        // console.log('dateSchedule: ' + vacancyData.itemSelected.fdVacTimeIniDt.split(' ')[0] + '-' + vacancyData.itemSelected.fcVacTimePeriodNm);
        // console.log('proprietaryName: ' + scheduleData.proprietaryName);
        // console.log('vehiclePlate: ' + vehicleData.vehiclePlate);
        // console.log('vehicleChassi: ' + vehicleData.vehicleChassi);
        // console.log('vehicleManufacturer: ' + vehicleData.vehicleManufacturerName);
        // console.log('vehicleModel: ' + vehicleData.vehicleModelName);
        // console.log('vehicleType: ' + vehicleData.vehicleTypeName);
        // console.log('vehicleColor: ' + vehicleData.vehicleColorName);
        // console.log('vehicleYear: ' + vehicleData.vehicleYear);
        // console.log('address: ' + vacancyData.addressDto.address + ', ' + vacancyData.addressDto.county + ' - ' + vacancyData.addressDto.zipCode + ' - ' + vacancyData.addressDto.city + ' - ' + vacancyData.addressDto.state);
        // console.log('addressName: ' + vacancyData.itemBaseWarehouse);
        // console.log('addressRef: ' + formScheduleData.pontoDeReferencia);
        // console.log('observation: ' + formScheduleData.obsReserveExternal);
        // console.log('timeService: ' + vacancyData.tempoTerm);
        // console.log('rate: ' + (vacancyData.valorTaxa === 0) ? 'ISENTO' : vacancyData.valorTaxa);
        // console.log('pointFixed : ' + String((vacancyData.warehouseDto.fcWarehouseTypeNm !== 'DOMICILIO')));
        // console.log('serviceTimeInit : ' + vacancyData.itemSelected.fdVacTimeIniDt.split(" ")[1]);
        // console.log('serviceTimeEnd" : ' + vacancyData.itemSelected.fdVacTimeEndDt.split(" ")[1]);
        // console.log('---------- FIM ----------');

        // const response =
        // await api.post<Response<String>>('/export-files-service/proofOfAppointment',
        //     {
        //             'protocol': scheduleInspec.fnReserveId,
        //             'dateSchedule': vacancyData.itemSelected.fdVacTimeIniDt.split(' ')[0] + '-' + vacancyData.itemSelected.fcVacTimePeriodNm,
        //             'proprietaryName': scheduleData.proprietaryName,
        //             'vehiclePlate': vehicleData.vehiclePlate || '',
        //             'vehicleChassi': vehicleData.vehicleChassi,
        //             'vehicleManufacturer': vehicleData.vehicleManufacturerName,
        //             'vehicleModel': vehicleData.vehicleModelName,
        //             'vehicleType': vehicleData.vehicleTypeName,
        //             'vehicleColor': vehicleData.vehicleColorName,
        //             'vehicleYear': vehicleData.vehicleYear,
        //             'address': vacancyData.addressDto.address + ', ' + vacancyData.addressDto.county + ' - ' + vacancyData.addressDto.zipCode + ' - ' + vacancyData.addressDto.city + ' - ' + vacancyData.addressDto.state,
        //             'addressName': vacancyData.itemBaseWarehouse,
        //             'addressRef': formScheduleData.pontoDeReferencia || '',
        //             'observation': formScheduleData.obsReserveExternal,
        //             'timeService': vacancyData.tempoTerm,
        //             'rate': vacancyData.valorTaxa === 0 ? 'ISENTO' : vacancyData.valorTaxa,
        //             'pointFixed': String(vacancyData.warehouseDto.fcWarehouseTypeNm !== 'DOMICILIO').toString(),
        //             'serviceTimeInit': (vacancyData.warehouseDto.fcWarehouseTypeNm !== 'DOMICILIO') ? vacancyData.itemSelected.fdVacTimeIniDt.split(" ")[1] : "",
        //             'serviceTimeEnd': (vacancyData.warehouseDto.fcWarehouseTypeNm !== 'DOMICILIO') ? vacancyData.itemSelected.fdVacTimeEndDt.split(" ")[1] : "",
        //             'observationTerm' : vacancyData.obs
        //     }, {
        //         headers: {
        //             'Content-Type': 'application/json',
        //         }
        //     }
        // ).then(response => {
        //     // console.log('RESPONSE : ', response.data);
        //     return response.data;
        // }).catch(exception => {
        //     // console.log('ERROR - ' + exception);
        //     return null;
        // });

        // if(response){

        //     saveAs(
        //         response?.data.toString(),
        //         "schedule.pdf",
        //         {autoBom: true}
        //       );
        // }else{
        //     message.error('Houve um problema na exportação do PDF, entre em contato com o administrador.');
        // }

        if (scheduleInspec.file) {
            downloadFromBase64("comprovante_agendamento.pdf", scheduleInspec.file)

        } else {
            message.error('Erro ao fazer download do comprovante')
        }
    }

    const steps = [
        {
            title: 'Identificação',
            content: <Identification formRef={form} company={appParameters.company}
                                     typeService={appParameters.typeService}
                                     secondaryColor={appParameters.secondaryColor}/>,
        },
        {
            title: 'Veiculo',
            content: <Vehicles secondaryColor={appParameters.secondaryColor} setVehicleData={setVehicleData}
                               scheduleVehicleData={scheduleData} formRef={form}/>,
        },
        {
            title: 'Confirmação de Dados',
            content: <ConfirmData cpfOrCnpj={scheduleData.proprietaryDocument}
                                  proprietaryName={scheduleData.proprietaryName} inserer={scheduleData.insurer}
                                  vehicleData={vehicleData} formRef={form} appParameters={appParameters}/>,
        },
        {
            title: 'Agenda',
            content: <Schedule secondaryColor={appParameters.secondaryColor}
                               cpfOrCnpj={scheduleData.proprietaryDocument} setVacancyData={setVacancyData}
                               setLoadStep={setLoadStep} resetStep={setResetSep} historyKey={historyKey}
                               vehicleData={vehicleData} formRef={form} setEnableNext={setEnableNext}
                               onFormChange={handleFormChange}/>,
        },
        {
            title: 'Finalização',
            content: <Finish isLoad={loadStep} proprietaryName={scheduleData.proprietaryName}
                             formScheduleData={formScheduleData} emailInformed={emailInformed} vehicleData={vehicleData}
                             vacancyData={vacancyData}/>,
        }
    ];

    const next = () => {
        setLoadStep(true);
        //Step Identificação
        console.log(current)
        if (current === 0) {
            // Se veio da tela de cancelamento, executa direto a consulta com base no CPF que veio como parâmetro na URL.
            if (cameFromCancelling && cpfCnpjParam) {
                setLoadStep(true);
                // TODO fazer buscar direto os veiculos
                api.get<Response<ScheduleData>>('scheduleExternal/findAllVehiclesByParameters',
                    {
                        headers: {
                            'cpfOrCnpj': NormalizeCpfOrCnpj(cpfCnpjParam),
                            newVirtualSchedule: newVirtualSchedule,
                            typeSchedule: typeSchedule
                        }
                    }).then(response => {

                    console.log('response: ' + JSON.stringify(response.data));

                    setScheduledata(response.data.data);

                    console.log(response.data.data.vehicleResponseDtoList)

                    if (response.data.data.vehicleResponseDtoList == null || response.data.data.vehicleResponseDtoList.length === 0) {
                        console.log('vamos parar por aqui')
                        Modal.warning(
                            {
                                title: 'Atenção!',
                                content: "Não foram encontrados veículos para realizar agendamento com o documento informado",
                                onOk: () => setResetSep(true),
                                okButtonProps: {
                                    style: {
                                        backgroundColor: appParameters.secondaryColor,
                                        borderColor: appParameters.secondaryColor
                                    }
                                }
                            }
                        )
                    } else {
                        /*
                        * @davidsantos
                        * Devido ao servidor não retornar corretamente os dados do objeto vehicleResponseDtoList, uma hora volta um array outra objeto,
                        * Foi feito um ajuste para que conseguíssemos interpretar o retorno errado do servidor.
                        */
                        if (!Array.isArray(response.data.data.vehicleResponseDtoList)) {
                            let vehicleDtoList = [] as Vehicle[];
                            vehicleDtoList.push(response.data.data.vehicleResponseDtoList);
                            response.data.data.vehicleResponseDtoList = vehicleDtoList;
                        }
                        if (response.data.data.vehicleResponseDtoList.length === 1) {

                            const vehicle = response.data.data.vehicleResponseDtoList[0];

                            shouldBlockSchedule(vehicle.fnRequisitionID)
                                .then(result => {

                                    if (result.error) {
                                        Modal.error({
                                            title: 'Erro',
                                            content: result.error,
                                            okButtonProps: {
                                                style: {
                                                    backgroundColor: appParameters.secondaryColor,
                                                    borderColor: appParameters.secondaryColor
                                                }
                                            }
                                        });

                                        setLoadStep(false);
                                        return;
                                    }

                                    if (result.blocked) {

                                        Modal.warning({
                                            title: 'Atenção!',
                                            content: `Requisição: ${vehicle.fnRequisitionID}. Existem contratos pendentes de assinatura`,
                                            okButtonProps: {
                                                style: {
                                                    backgroundColor: appParameters.secondaryColor,
                                                    borderColor: appParameters.secondaryColor
                                                }
                                            }
                                        });

                                        setLoadStep(false);
                                        return;
                                    }

                                    Modal.warning({
                                        title: 'Atenção!',
                                        width: 720,
                                        content: (
                                            <span
                                                dangerouslySetInnerHTML={{
                                                    __html: vehicle.term.replace('<>', '')
                                                }}
                                            />
                                        ),
                                        onOk: () => {
                                            setCurrent(current + 2);
                                            setVehicleData(vehicle);
                                        },
                                        okButtonProps: {
                                            style: {
                                                backgroundColor: appParameters.secondaryColor,
                                                borderColor: appParameters.secondaryColor
                                            }
                                        }
                                    });

                                })
                                .catch(error => {
                                    console.log('Erro inesperado:', error);

                                    Modal.error({
                                        title: 'Erro',
                                        content: 'Erro inesperado ao validar bloqueio.',
                                        okButtonProps: {
                                            style: {
                                                backgroundColor: appParameters.secondaryColor,
                                                borderColor: appParameters.secondaryColor
                                            }
                                        }
                                    });

                                    setLoadStep(false);
                                });

                        } else {
                            setCurrent(current + 1);
                        }
                    }
                    setLoadStep(false);
                });
            } else if (!cameFromCancelling) {
                // Se não veio da tela de cancelamento, segue o passo a passo manual, onde o usuário precisa informar manualmente seu CPF/CNPJ e prosseguir.
                form.validateFields()
                    .then(async identification => {
                        console.log('---------- INICIO ----------');
                        console.log('URL : scheduleExternal/findAllVehiclesByParameters');
                        console.log('cpfOrCnpj: ' + NormalizeCpfOrCnpj(identification.cpfCnpj));

                        const response = await api.get<Response<ScheduleData>>('scheduleExternal/findAllVehiclesByParameters',
                            {
                                headers: {
                                    'cpfOrCnpj': NormalizeCpfOrCnpj(identification.cpfCnpj),
                                    newVirtualSchedule: newVirtualSchedule,
                                    typeSchedule: typeSchedule
                                }
                            })
                        console.log('response: ' + JSON.stringify(response.data));
                        console.log('---------- FIM ----------');
                        setScheduledata(response.data.data);

                        console.log(response.data.data.vehicleResponseDtoList)

                        if (response.data.data.vehicleResponseDtoList == null || response.data.data.vehicleResponseDtoList.length === 0) {
                            console.log('vamos parar por aqui')
                            Modal.warning(
                                {
                                    title: 'Atenção!',
                                    content: "Não foram encontrados veículos para realizar agendamento com o documento informado",
                                    onOk: () => setResetSep(true),
                                    okButtonProps: {
                                        style: {
                                            backgroundColor: appParameters.secondaryColor,
                                            borderColor: appParameters.secondaryColor
                                        }
                                    }
                                }
                            )
                        } else {
                            /*
                            * @davidsantos
                            * Devido ao servidor não retornar corretamente os dados do objeto vehicleResponseDtoList, uma hora volta um array outra objeto,
                            * Foi feito um ajuste para que conseguíssemos interpretar o retorno errado do servidor.
                            */
                            if (!Array.isArray(response.data.data.vehicleResponseDtoList)) {
                                let vehicleDtoList = [] as Vehicle[];
                                vehicleDtoList.push(response.data.data.vehicleResponseDtoList);
                                response.data.data.vehicleResponseDtoList = vehicleDtoList;
                            }
                            if (response.data.data.vehicleResponseDtoList.length === 1) {

                                const vehicle = response.data.data.vehicleResponseDtoList[0];

                                shouldBlockSchedule(vehicle.fnRequisitionID)
                                    .then(result => {

                                        if (result.error) {
                                            Modal.error({
                                                title: 'Atenção!',
                                                content: result.error,
                                                okButtonProps: {
                                                    style: {
                                                        backgroundColor: appParameters.secondaryColor,
                                                        borderColor: appParameters.secondaryColor
                                                    }
                                                }
                                            });

                                            setLoadStep(false);
                                            return;
                                        }

                                        if (result.blocked) {

                                            Modal.warning({
                                                title: 'Atenção!',
                                                content: `Requisição: ${vehicle.fnRequisitionID}. Existem contratos pendentes de assinatura`,
                                                okButtonProps: {
                                                    style: {
                                                        backgroundColor: appParameters.secondaryColor,
                                                        borderColor: appParameters.secondaryColor
                                                    }
                                                }
                                            });

                                            setLoadStep(false);
                                            return;
                                        }

                                        // 🟢 LIBERADO
                                        Modal.warning({
                                            title: 'Atenção!',
                                            width: 720,
                                            content: (
                                                <span
                                                    dangerouslySetInnerHTML={{
                                                        __html: vehicle.term.replace('<>', '')
                                                    }}
                                                />
                                            ),
                                            onOk: () => {
                                                setCurrent(current + 2);
                                                setVehicleData(vehicle);
                                            },
                                            okButtonProps: {
                                                style: {
                                                    backgroundColor: appParameters.secondaryColor,
                                                    borderColor: appParameters.secondaryColor
                                                }
                                            }
                                        });

                                    })
                                    .catch(error => {

                                        console.log('Erro inesperado:', error);

                                        Modal.error({
                                            title: 'Erro',
                                            content: 'Erro inesperado ao validar bloqueio.',
                                            okButtonProps: {
                                                style: {
                                                    backgroundColor: appParameters.secondaryColor,
                                                    borderColor: appParameters.secondaryColor
                                                }
                                            }
                                        });

                                        setLoadStep(false);
                                    });

                            } else {
                                setCurrent(current + 1);
                            }
                        }
                        setLoadStep(false);
                    })
                    .catch(async error => {
                        if (error.response) {
                            if (error.response.status === 400) {
                                if (window.location.href.includes(Constants.LINK_SUHAI)) {
                                    form.setFields([{name: 'cpfCnpj', errors: [Constants.MSG_ERRO_SUHAI]}])
                                } else {
                                    form.setFields([{name: 'cpfCnpj', errors: error.response.data.errors}])
                                }
                            } else if (error.response.status === 404) {
                                form.setFields([{
                                    name: 'cpfCnpj',
                                    errors: ['CPF/CNPJ não encontrado na base de dados.']
                                }])
                            } else {
                                form.setFields([{name: 'cpfCnpj', errors: ['Ocorreu um erro, tente novamente!']}])
                            }
                        } else {
                            form.setFields([{
                                name: 'cpfCnpj',
                                errors: ['Não foram encontrados veículos para realizar agendamento com o documento informado']
                            }])
                        }

                        setLoadStep(false);
                    })
            }
        }
        //Step Veículo
        if (current === 1) {
            shouldBlockSchedule(vehicleData.fnRequisitionID)
                .then(result => {

                    if (result.error) {
                        Modal.error({
                            title: 'Atenção!',
                            content: result.error,
                            okButtonProps: {
                                style: {
                                    backgroundColor: appParameters.secondaryColor,
                                    borderColor: appParameters.secondaryColor
                                }
                            }
                        });

                        setLoadStep(false);
                        return;
                    }

                    if (result.blocked) {

                        Modal.warning({
                            title: 'Atenção!',
                            content: `Requisição: ${vehicleData.fnRequisitionID}. Existem contratos pendentes de assinatura`,
                            okButtonProps: {
                                style: {
                                    backgroundColor: appParameters.secondaryColor,
                                    borderColor: appParameters.secondaryColor
                                }
                            }
                        });

                        setLoadStep(false);
                        return;
                    }

                    form.validateFields()
                        .then(async vehicleDataForm => {

                            Modal.warning({
                                title: 'Atenção!',
                                width: 720,
                                content: (
                                    <span
                                        dangerouslySetInnerHTML={{
                                            __html: vehicleData.term.replace('<>', '')
                                        }}
                                    />
                                ),
                                onOk: () => setCurrent(current + 1),
                                okButtonProps: {
                                    style: {
                                        backgroundColor: appParameters.secondaryColor,
                                        borderColor: appParameters.secondaryColor
                                    }
                                }
                            });

                            setLoadStep(false);
                        });

                })
                .catch(error => {

                    console.log('Erro inesperado:', error);

                    Modal.error({
                        title: 'Erro',
                        content: 'Erro inesperado ao validar bloqueio.',
                        okButtonProps: {
                            style: {
                                backgroundColor: appParameters.secondaryColor,
                                borderColor: appParameters.secondaryColor
                            }
                        }
                    });

                    setLoadStep(false);
                });
        }

        //Step Confirmação de Dados
        if (current === 2) {
            form.validateFields()
                .then(async confirmData => {

                    console.log('---------- INICIO ----------');
                    console.log('URL : scheduleExternal/createHistory');
                    console.log('fnRequisitionID: ' + vehicleData.fnRequisitionID);

                    if (!vehicleData.addressDto) {
                        let newVehicleData = vehicleData;
                        newVehicleData.addressDto = form.getFieldValue('addressDto');
                        setVehicleData(newVehicleData);
                    }

                    setEmailInformed(confirmData.email);
                    const response = await api.post<Response<HistoryKey>>('scheduleExternal/createHistory',
                        {
                            'email': confirmData.email,
                            'fnRequisitionID': vehicleData.fnRequisitionID,
                        }, {
                            headers: {
                                newVirtualSchedule: newVirtualSchedule
                            }
                        })

                    console.log('response: ' + JSON.stringify(response.data));
                    console.log('---------- FIM ----------');

                    setHistoryKey(response.data.data.historyKey)
                    setCurrent(current + 1);
                    setLoadStep(false);
                })
                .catch(error => {
                    setLoadStep(false);
                })
        }

        //Step Agenda
        if (current === 3) {
            form.validateFields()
                .then(async formScheduleData => {
                    setFormScheduleData(formScheduleData);
                    Modal.warning(
                        {
                            title: 'Atenção!',
                            width: 720,
                            content: <span dangerouslySetInnerHTML={{__html: vacancyData?.term.replace('<>', '')}}/>,
                            onOk: () => setCurrent(current + 1),
                            okButtonProps: {
                                style: {
                                    backgroundColor: appParameters.secondaryColor,
                                    borderColor: appParameters.secondaryColor
                                }
                            }

                        }
                    )
                })
            setLoadStep(false);
        }
    };

    const finishProcess = () => {
        setLoadStep(true)

        console.log('---------- INICIO ----------');
        console.log('URL : scheduleExternal/schedule');
        console.log('contactName: ' + formScheduleData.contactName);
        console.log('contactDDD: ' + formScheduleData.contactDDD);
        console.log('contactNumber: ' + StringOnlyNumbers(formScheduleData.contactNumber));
        console.log('valorTaxa: ' + vacancyData.valorTaxa);
        console.log('acceptTaxa: ' + vacancyData.acceptedTaxa);
        console.log('itemSelected: ' + JSON.stringify(vacancyData.itemSelected));
        console.log('addressDto: ' + JSON.stringify(vacancyData.addressDto));
        console.log('warehouseDto: ' + JSON.stringify(vacancyData.warehouseDto));
        console.log('fnRequisitionID: ' + vehicleData.fnRequisitionID);
        console.log('obsReserveExternal: ' + formScheduleData.obsReserveExternal);

        api.post<Response<ScheduleInspection>>('scheduleExternal/schedule', {
            contactName: formScheduleData.contactName,
            contactDDD: formScheduleData.contactDDD,
            contactNumber: StringOnlyNumbers(formScheduleData.contactNumber),
            valorTaxa: vacancyData.valorTaxa,
            acceptTaxa: vacancyData.acceptedTaxa,
            itemSelected: vacancyData.vacancyTimeDto,
            addressDto: vehicleData.addressDto,
            warehouseDto: vacancyData.warehouseDto,
            fnRequisitionID: vehicleData.fnRequisitionID,
            obsReserveExternal: formScheduleData.obsReserveExternal,
            vacancyDto: vacancyData.vacancyTimeDto.vacancyDto,
            pontoDeReferencia: 'Teste de Dev'
        }, {
            headers: {
                fnRequisitionId: vehicleData.fnRequisitionID,
                email: emailInformed,
                newVirtualSchedule: newVirtualSchedule
            }
        }).then(response => {
            setLoadStep(false)
            console.log('response: ' + JSON.stringify(response.data));
            console.log('---------- FIM ----------');
            //A funcao de download está pegando uma referencia antiga deste estado
            Modal.success(
                {
                    title: 'Sucesso!',
                    content: <>O agendamento foi realizado com sucesso!<p/><Button
                        onClick={() => onDownloadPdf(response.data.data)}>Baixar PDF</Button></>,
                    onOk: () => {
                        // Quando o usuário chegar na agenda através do cancelamento e agendar novamente, ele será
                        // redirecionado para o início da agenda sem o parâmetro do CPF selecionado anteriormente.
                        // Isso permite que o próprio usuário escolha qual CPF utilizar para agendar.
                        const urlAtual = new URL(window.location.href);
                        urlAtual.searchParams.delete('cpfCnpjParam'); // Remove o parâmetro do CPF da (URL) atual
                        const novaUrl = urlAtual.toString(); // Converte o objeto URL de volta para uma ‘string’
                        window.location.replace(novaUrl); // Redireciona para a nova URL sem o parâmetro do CPF
                    },
                    closable: false,
                    okButtonProps: {
                        style: {
                            backgroundColor: appParameters.secondaryColor,
                            borderColor: appParameters.secondaryColor
                        }
                    }
                }
            );
        }).catch(error => {
            setLoadStep(false)
            if (error.response != undefined) {
                message.error(error.response.data.errors.toString())
            } else {
                message.error(Constants.ERROR_CONTACT_SUPORT);
            }
        })
    }

    const shouldBlockSchedule = async (
        fnRequisitionId: number
    ): Promise<{ blocked: boolean; error?: string }> => {
        try {
            const response = await api.get<boolean>(
                'scheduleExternal/shouldBlockSchedule',
                {
                    headers: { fnRequisitionId }
                }
            );

            return {
                blocked: !!response.data
            };

        } catch (error: any) {

            const backendMessage =
                error?.response?.data?.message ||
                error?.message;

            const userMessage =
                'Não foi possível verificar assinaturas pendentes em contratos. Tente novamente em instantes.';

            const finalMessage = backendMessage
                ? `${userMessage}\n\nDetalhe técnico: ${backendMessage}`
                : userMessage;

            return {
                blocked: true,
                error: finalMessage
            };
        }
    };

    const prev = () => {
        if (current === 2 && (scheduleData.vehicleResponseDtoList == null || scheduleData.vehicleResponseDtoList.length <= 1)) {
            setCurrent(current - 2);
        } else {
            setCurrent(current - 1);
        }
    };

    return (
        <AntLayout>
            <PageHeader headercolor={appParameters.primaryColor}>
                <Logo src={appParameters.urlLogo}/>
            </PageHeader>
            <PageContent>
                <Title
                    bordercolor={appParameters.secondaryColor}
                    items={[
                        { title: 'Central de Agendamento Online' },
                        { title: appParameters.typeService }
                    ]}
                />
                <Container>
                    <ContainerStep>
                        <Space direction="vertical" size="middle" style={{display: 'flex'}}>
                            <ScheduleStep stepcolor={appParameters.secondaryColor} current={current}>
                                {steps.map((item, key) => (
                                    <Step key={item.title} title={item.title} icon={current === key && loadStep &&
                                        <LoadingOutlined color={appParameters.secondaryColor}/>}/>
                                ))}
                            </ScheduleStep>
                            <AppSpin
                                color={appParameters.secondaryColor}
                                spinning={loadStep}
                                tip={
                                    <span
                                        style={{
                                            display: 'inline-block',
                                            backgroundColor: '#fff',
                                            borderRadius: '8px',
                                            padding: '6px 12px',
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                        }}
                                    >
                                    Aguarde, pode levar 1 minuto
                                    <span
                                        style={{
                                            display: 'inline-block',
                                            width: '3ch',
                                            letterSpacing: '0.08em',
                                            textAlign: 'left',
                                            marginLeft: '4px',
                                        }}
                                    >
                                      {dots}
                                    </span>
                                  </span>
                                }
                            >
                                <StepsBody className="steps-content">
                                    {steps[current].content}
                                </StepsBody>

                                <Row gutter={16} justify="center" style={{paddingTop: '10px'}}>
                                    <Col span={24}>
                                        <div className="steps-action">
                                            {current > 0 && (
                                                <AppButton type="default" color={appParameters.secondaryColor}
                                                           style={{margin: '0 8px'}} onClick={() => prev()}>
                                                    Anterior
                                                </AppButton>
                                            )}
                                            {current < steps.length - 1 && (
                                                <AppButton type="default" color={appParameters.secondaryColor}
                                                           onClick={next} disabled={current === 3 && !enableNext}>
                                                    Proximo
                                                </AppButton>
                                            )}
                                            {current === steps.length - 1 && (
                                                <AppButton disabled={loadStep} type="primary"
                                                           color={appParameters.secondaryColor} onClick={finishProcess}>
                                                    Finalizar
                                                </AppButton>
                                            )}
                                        </div>
                                        <div
                                            style={{
                                                margin: "auto",
                                                display: "table",
                                            }}
                                        >
                                            <h4>
                                                Caso já tenha realizado o agendamento e queira cancelar,{" "}
                                                <RouterLink to="/layout-cancellation">clique aqui.</RouterLink>
                                            </h4>
                                        </div>

                                    </Col>
                                </Row>
                            </AppSpin>
                        </Space>
                    </ContainerStep>

                </Container>
            </PageContent>
            <PageFooter footercolor={appParameters.primaryColor}
                        fontcolor={appParameters.fontColor}>{appParameters.footerText}</PageFooter>
        </AntLayout>
    );

}

export default Layout;
